import { createContext } from 'react';

const BreadcrumbsContext = createContext({
  prev: [],
  current: [],
  navigation: [],
  icon: null,
  title: null,
  setTitle: () => {},
  setParams: () => {},
  params: null,
});

export default BreadcrumbsContext;
